export default "__VITE_ASSET__BqMDsyiS__"